import React from 'react';

import {
  AddBox,
  Description,
  Ballot,
  AccountBalanceOutlined,
  LocalHospitalOutlined,
  WarningOutlined,
  EnhancedEncryptionOutlined,
  DoneAllOutlined,
  PlaceOutlined,
  LocationCityOutlined,
  Settings,
  History
} from '@material-ui/icons';
import { SUBSCRIPTOR_LIST_PATH, SUBSCRIPTOR_ADD_PATH } from './subscriptor';
import { USER_LIST_PATH } from './user';
import {
  WARRANTY_LIST_PATH,
  maintainerFormRouters,
  WARRANTY_PATHS,
  SERVICE_PATHS,
  SERVICE_LIST_PATH,
  RISK_LIST_PATH,
  RISK_PATHS,
  INSURANCE_LIST_PATH,
  INSURANCE_PATHS,
  HEALTH_PLAN_PATHS,
  HEALTH_PLAN_LIST_PATH,
  REGION_LIST_PATH,
  REGION_PATHS,
  COMMUNE_LIST_PATH,
  COMMUNE_PATHS,
  LOG_LIST_PATH
} from './maintainer';
import { MAINTAINER_KEY } from '../libraries/constants';

export const isActiveLink = childrens => (match, location) => {
  let { pathname } = location;
  if (pathname.includes('edit')) {
    pathname = pathname.split('/');
    pathname[3] = ':id';
    pathname = pathname.join('/');
  }

  return childrens.filter(elem => elem.path === pathname).length;
};

export const navBarButtons = [
  {
    icon: <AddBox />,
    text: 'Nueva solicitud',
    permissions: ['ADD_SUBSCRIPTOR'],
    to: SUBSCRIPTOR_ADD_PATH
  },
  {
    icon: <Description />,
    text: 'Búsqueda',
    permissions: ['SUBSCRIPTOR_LIST'],
    to: SUBSCRIPTOR_LIST_PATH
  },
  {
    icon: <Ballot />,
    text: 'Mantenedores',
    key: MAINTAINER_KEY,
    permissions: ['MAINTAINER_LIST'],
    childrens: maintainerFormRouters
  },
  {
    icon: <Settings />,
    text: 'Usuarios',
    permissions: ['USER_LIST'],
    to: USER_LIST_PATH
  },
  {
    icon: <History />,
    text: 'Visor de logs',
    permissions: ['LOG_LIST'],
    to: LOG_LIST_PATH
  }
];

export const SecondaryNavigationButtons = {
  [MAINTAINER_KEY]: [
    {
      icon: <AccountBalanceOutlined />,
      text: 'Tipo de garantía',
      to: WARRANTY_LIST_PATH,
      permissions: ['WARRANTY_LIST'],
      childrens: WARRANTY_PATHS
    },
    {
      icon: <LocalHospitalOutlined />,
      text: 'Prestación',
      to: SERVICE_LIST_PATH,
      permissions: ['SERVICE_LIST'],
      childrens: SERVICE_PATHS
    },
    {
      icon: <WarningOutlined />,
      text: 'Riesgo médico',
      to: RISK_LIST_PATH,
      permissions: ['RISK_LIST'],
      childrens: RISK_PATHS
    },
    {
      icon: <EnhancedEncryptionOutlined />,
      text: 'Previsión',
      to: INSURANCE_LIST_PATH,
      permissions: ['INSURANCE_LIST'],
      childrens: INSURANCE_PATHS
    },
    {
      icon: <DoneAllOutlined />,
      text: 'Tramo',
      to: HEALTH_PLAN_LIST_PATH,
      permissions: ['HEALTH_PLAN_LIST'],
      childrens: HEALTH_PLAN_PATHS
    },
    {
      icon: <PlaceOutlined />,
      text: 'Región',
      to: REGION_LIST_PATH,
      permissions: ['REGION_LIST'],
      childrens: REGION_PATHS
    },
    {
      icon: <LocationCityOutlined />,
      text: 'Comuna',
      to: COMMUNE_LIST_PATH,
      permissions: ['COMMUNE_LIST'],
      childrens: COMMUNE_PATHS
    }
  ]
};
